/**
 * SSOButton Component - Modern Design
 * Azure AD Sign-in button with Microsoft branding
 * Follows React conventions and accessibility guidelines
 */

import React from 'react';
import { Button } from 'antd';
import { SSOButtonProps } from '../../types/auth.types';
import { useResponsiveDesign } from '../../hooks/useResponsiveDesign';
import styles from './SSOButton.module.scss';

const MicrosoftIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true">
    <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
    <rect x="12" y="1" width="9" height="9" fill="#00a4ef"/>
    <rect x="1" y="12" width="9" height="9" fill="#7fba00"/>
    <rect x="12" y="12" width="9" height="9" fill="#ffb900"/>
  </svg>
);

const SSOButton: React.FC<SSOButtonProps> = ({
  onClick,
  loading = false,
  disabled = false,
  className = "",
  children = "SIGN IN WITH AZURE AD",
}) => {
  const { isMobile } = useResponsiveDesign();

  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      block
      size="large"
      className={`${styles.ssoButton} ${className}`}
      aria-label="Sign in with Azure Active Directory"
      role="button"
    >
      <span className={styles.buttonContent}>
        {!loading && (
          <MicrosoftIcon size={isMobile ? 16 : 20} />
        )}
        <span className={styles.buttonText}>
          {children}
        </span>
      </span>
    </Button>
  );
};

SSOButton.displayName = 'SSOButton';

export default SSOButton;